import { render, staticRenderFns } from "./SeparateIncidentsModal.vue?vue&type=template&id=23b38647&scoped=true"
import script from "./SeparateIncidentsModal.vue?vue&type=script&lang=js"
export * from "./SeparateIncidentsModal.vue?vue&type=script&lang=js"
import style0 from "./SeparateIncidentsModal.vue?vue&type=style&index=0&id=23b38647&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b38647",
  null
  
)

export default component.exports